import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-963b2b26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "banner" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "tab-list" }
const _hoisted_7 = { class: "principally" }

import { ref, watch } from "vue";
import { useRouter } from "vue-router";

type bannerProps = {
  title: string;
  desc?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();
const bannerDesc = ref<bannerProps>();
bannerDesc.value = {
  title: "Guardian Of Your Life",
  desc: `守护你一生`,
};

const lineShow = ref("company");

const userRouter = useRouter();
watch(
  () => userRouter.currentRoute.value.fullPath,
  (val: string) => {
    if (val.split("/")[2] === "company") {
      lineShow.value = "company";
    } else {
      lineShow.value = "recruit";
    }
  },
  { immediate: true, deep: true }
);

const jump = (val: string) => {
  router.push(val);
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(bannerDesc.value?.desc), 1),
        _createElementVNode("p", {
          class: "desc",
          innerHTML: bannerDesc.value?.title
        }, null, 8, _hoisted_5)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("ul", _hoisted_7, [
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (jump('/about/company'))),
          class: _normalizeClass(lineShow.value == 'company' ? 'active' : '')
        }, " 公司介绍 ", 2),
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (jump('/about/recruit'))),
          class: _normalizeClass(lineShow.value == 'recruit' ? 'active' : '')
        }, " 招贤纳士 ", 2)
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})